export const AWAITING_VOICEOVER_CHECK = 'awaiting_voiceover_check';
export const CHECKING_VOICEOVER = 'checking_voiceover';
export const MIXING = 'mixing';
export const TRANSCODING = 'transcoding';
export const PENDING_APPROVAL = 'pending_approval';
export const REVIEW = 'review_audio';

export const PROCESSING = 'processing';

export const ACTIVE = 'active';
export const READY = 'ready';
export const COMPLETE = 'complete';
export const STOPPED = 'stopped';
export const REJECTED = 'rejected';

export const UNAPPROVED_STATUS_TYPES = {
  [AWAITING_VOICEOVER_CHECK]: 'Awaiting Voiceover',
  [CHECKING_VOICEOVER]: 'Checking Voiceover',
  [MIXING]: 'Mixing',
  [TRANSCODING]: 'Transcoding',
  [REVIEW]: 'Review Audio',
  [PENDING_APPROVAL]: 'Pending Approval',
};

export const APPROVED_STATUS_TYPES = {
  [READY]: 'Ready',
  [ACTIVE]: 'Active',
  [COMPLETE]: 'Complete',
  [STOPPED]: 'Stopped',
};

const processingTypes = Object.keys(UNAPPROVED_STATUS_TYPES)
  .filter(s => s !== PENDING_APPROVAL && s !== REVIEW)
  .join('.');

export const PROCESSING_STATUS_TYPES = {
  [processingTypes]: 'Processing',
};



// WEBPACK FOOTER //
// ./src/config/adStatusTypes.js